/* loader
========================================================= */
export function loading($) {
  const loader = $('.loader-wrap');
  // ページの読み込みが完了したらアニメーションを非表示
  $(window).on('load', function () {
    loader.fadeOut();
  });
}
